import { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Field as BaseField } from "rc-field-form";
import { Input } from "reactstrap";
import Field from "../../../../../../../../../components/Field";
import Checkbox from "../../../../../../../../../components/Inputs/Checkbox";
import Modal from "../../../../../../../../../components/Modal";
import Details from "./Details";

export const getFieldName = (name) => ["overtime", "weekly-overtime", name];

function WeeklyOvertime({ disabled }) {
	const { t } = useTranslation();

	const [visible, setVisible] = useState(false);

	const openModal = useCallback(() => setVisible(true), [setVisible]);

	const closeModal = useCallback(() => setVisible(false), [setVisible]);

	return (
		<div className="calculation-group-rule">
			<div className="d-flex align-items-center mr-1 w-100">
				<Field
					name={getFieldName("status")}
					valuePropName="checked"
					noStyle
					className="mb-0"
				>
					<Checkbox id="weekly-overtime" disabled={disabled}>
						{t("weekly-overtime")}
					</Checkbox>
				</Field>
			</div>

			<BaseField noStyle shouldUpdate>
				{({ }, { }, { getFieldValue, getFieldError }) => {
					const data = getFieldValue(["overtime", "weekly-overtime"]);

					const status = data.status;
					const error = getFieldError(getFieldName("value"));

					return (
						<>
							<div className="d-flex align-items-center">
								<BaseField
									name={getFieldName("value")}
									rules={
										status
											? [
												{
													required: true,
													message: t(
														"required-weekly-overtime",
													),
												},
												{
													validator(_, value) {
														if (
															Number(value) <=
															0
														) {
															return Promise.reject(
																new Error(
																	t(
																		"weekly-overtime-bigger-than-zero",
																	),
																),
															);
														}
														return Promise.resolve();
													},
												},
											]
											: undefined
									}
									noStyle
									dependencies={[getFieldName("status")]}
									className=" mb-0"
								>
									<Input
										className="border-primary"
										size="sm"
										readOnly={!status}
										type="number"
										disabled={disabled}
									/>
								</BaseField>

								<BaseField
									name={getFieldName("defaultPayCode")}
									hidden
								/>

								<BaseField
									name={getFieldName("payCodes")}
									hidden
								/>

								<BaseField
									name={getFieldName("hourTypes")}
									hidden
								/>

								<BaseField
									name={getFieldName("premiumPayCode")}
									hidden
								/>

								<BaseField
									name={getFieldName("splitOvertime")}
									hidden
								/>

								<BaseField
									name={getFieldName("unitPayCode")}
									hidden
								/>

								<p className="text-sm mx-2 mb-0 text-center">
									{t("hours-week")}
								</p>
							</div>

							<div className="d-flex align-items-center justify-content-end">
								<FontAwesomeIcon
									className="text-sm cursor-pointer"
									icon={faPen}
									onClick={(status || disabled) ? openModal : undefined}
								/>
							</div>

							{error && (
								<span className="invalid-feedback d-block">
									{error[0]}
								</span>
							)}

							{visible && (
								<Modal
									title={t("weekly-overtime-rule-parameters")}
									isOpen={visible}
									close={closeModal}
									centered={true}
								>
									<Details
										close={closeModal}
										overtime={data}
										disabled={disabled}
									/>
								</Modal>
							)}
						</>
					);
				}}
			</BaseField>
		</div>
	);
}

export default WeeklyOvertime;
